import List from './List';
import reducer from './reducer';

const BookkeeperOrdersChanged = {
  List,
  reducer
};

export default BookkeeperOrdersChanged;
